import {
    Flex,
    Image,
    Modal,
    ModalContent,
    ModalOverlay,
    useMediaQuery,
} from "@chakra-ui/react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

interface IPreviewImageModalProps {
    isOpen: boolean;
    onClose: () => void;
    previewImage: string;
}

function PreviewImageModal(props: IPreviewImageModalProps) {
    const [isMobile] = useMediaQuery("(max-width: 480px)");

    return (
        <Modal isOpen={props.isOpen} onClose={props.onClose} size={"full"}>
            <ModalOverlay bg={"black"} />
            <ModalContent bg={"blackAlpha"} w="full" h="full">
                <Flex
                    w={"full"}
                    h={"full"}
                    flexDir="column"
                    justifyContent={"center"}
                    alignItems="center"
                    gap={"20px"}
                >
                    <Flex w="full" justifyContent={"flex-end"} px="20px">
                        <Image
                            src="/assets/images/icn_close_wh.svg"
                            boxSize={"24px"}
                            onClick={props.onClose}
                        />
                    </Flex>

                    <TransformWrapper>
                        <TransformComponent>
                            <Image
                                src={props.previewImage}
                                objectFit="contain"
                                style={{
                                    width: "100vw",
                                    aspectRatio: isMobile ? 3 / 4 : 1,
                                }}
                            />
                        </TransformComponent>
                    </TransformWrapper>
                </Flex>
            </ModalContent>
        </Modal>
    );
}
export default PreviewImageModal;
